import React, { useContext } from 'react';
export const LanguageContext = /*#__PURE__*/React.createContext({});
export const LanguageContextProvider = _ref => {
  let {
    language,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(LanguageContext.Provider, {
    value: {
      language
    }
  }, children);
};
export function useLanguageContext() {
  const context = useContext(LanguageContext);
  return context;
}
//# sourceMappingURL=LanguageContext.js.map